import { FC } from 'react';
import { Box, Icon, Link, Text, Title } from '@nimbus-ds/components';
import { IconProps } from '@nimbus-ds/icons';
import { SubmitButton } from 'commons/components';
import { dateFormat, Format } from 'commons/utils/date';
import { useTranslationAccount } from 'domains/Account/hooks';
import useGetPlanDebt from 'domains/Auth/hooks/useGetPlanDebt';

export interface DisabledStoreContentCommonProps {
  iconSource: FC<IconProps>;
  localePath: string;
  primaryButtonAction: () => void;
  secondaryButtonAction: () => void;
  isLoadingPrimaryAction?: boolean;
}

export default function DisabledStoreContentCommon({
  iconSource,
  localePath,
  primaryButtonAction,
  secondaryButtonAction,
  isLoadingPrimaryAction,
}: Readonly<DisabledStoreContentCommonProps>) {
  const t = useTranslationAccount('canceledStorePage');
  const { planDebtData } = useGetPlanDebt();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap="4">
      <Icon color="primary-textLow" source={iconSource({ size: 'large' })} />
      <Title as="h4" textAlign="center">
        {t(`${localePath}.title`)}
      </Title>
      <Text textAlign="center">
        {t(`${localePath}.subTitle`, {
          storeDownDate:
            planDebtData?.storeDownDate &&
            dateFormat(planDebtData?.storeDownDate, Format.DD_MM),
        })}
      </Text>
      <Box display="flex" flexDirection="row" gap="2" justifyContent="center">
        <SubmitButton
          onClick={primaryButtonAction}
          isLoading={isLoadingPrimaryAction}
        >
          {t(`${localePath}.primaryButton`)}
        </SubmitButton>
        <Link
          fontSize="highlight"
          onClick={secondaryButtonAction}
          textDecoration="none"
          appearance="primary"
        >
          {t(`${localePath}.secondaryButton`)}
        </Link>
      </Box>
    </Box>
  );
}
